import { TFunction } from "i18next";
import { I18nError } from "./I18nError";

/**
 * A query filled a whole page of `limit` records, so its result may be incomplete. Deterministic:
 * retrying gives the same result, only a narrower selection helps.
 */
export class ResultsCapError extends I18nError {
  constructor(
    readonly typeName: string,
    readonly limit: number,
  ) {
    super(`${typeName} query returned ${limit} records, the result may be incomplete.`);
    this.name = "ResultsCapError";
  }

  i18nMessage(t: TFunction): string {
    return t("error.resultsCap", { type: this.typeName, count: this.limit });
  }
}
